<template>
  <div class="bg-white p-8">
    <el-dialog :visible.sync="centerDialogVisible" width="30%" center>
      <template slot="title">
        <p class="text-lg text-white">Uploader</p>
      </template>
      <div class="p-2">
        <el-upload
          class="upload-demo"
          drag
          action=""
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div>
        </el-upload>
        <div class="flex justify-center mt-2">
          <vs-button
            variant="primary"
            class="rounded-lg bg-primary border-0 text-white font-semibold py-3 px-4 sm-fsize14"
          >
            Submts
          </vs-button>
        </div>
      </div>
    </el-dialog>
    <div class="flex gap-6 mt-12 w-full pb-20">
      <div class="w-5/12">
        <ol class="grid grid-cols-1 gap-8 olnumber">
          <li class="flex items-start gap-2 text-8f8f8f text-lg font-semibold">
            <span class="text-black">1. </span> Open the domain's
            <p
              class="text-black text-lg underline flex items-center gap-2 cursor-pointer font-semibold"
            >
              DNS Management
              <feather-icon
                icon="ExternalLinkIcon"
                svgClasses="w-5 h-5"
                class="text-black"
              />
            </p>
          </li>

          <li class="block items-start gap-2 text-8f8f8f text-lg font-semibold">
            <span class="text-black">2. </span>
            Scroll down to
            <span class="text-black">Nameservers and </span>click or to tap
            <span class="text-black">change </span>
          </li>
          <li class="flex items-start gap-2 text-8f8f8f text-lg font-semibold">
            <span class="text-black">3. </span>
            Select
            <span class="text-black">Enter my own Nameservers (advanced)</span>
          </li>
          <li class="flex items-start gap-2 text-8f8f8f text-lg font-semibold">
            <span class="text-black">4. </span>
            Copy and paste the two nameservers records below into the
            nameservers feilds. If you already have custom nameservers replace
            them with the Squarespace ones.
          </li>
          <li class="flex items-start gap-2 text-8f8f8f text-lg font-semibold">
            <span class="text-black">5. </span>
            <span class="gap-1">
              When you're updated the nameservers settings, click or tap
              <span class="text-black">Save</span>
            </span>
          </li>
        </ol>
      </div>
      <div class="">
        <div style="height: 850px">
          <el-steps
            direction="vertical"
            :active="activeSteps"
            finish-status="success"
          >
            <el-step></el-step>
            <el-step></el-step>
            <el-step></el-step>
            <el-step></el-step>
            <el-step></el-step>
          </el-steps>
        </div>
      </div>
      <div class="w-6/12">
        <div class="height-step">
          <div class="w-full">
            <label class="text-dark fsize16 font-semibold">Add Domain</label>
            <div class="flex items-center mt-2">
              <div class="w-9/12">
                <el-input
                  placeholder="example.com"
                  maxlength="50"
                  v-model="domainName"
                ></el-input>
              </div>
              <div class="w-3/12 flex justify-end">
                <vs-button
                  variant="primary"
                  class="rounded-full bg-primary border-0 text-white font-semibold py-3 px-4 sm-fsize14"
                  @click="addDomain"
                >
                  Add Domain
                </vs-button>
              </div>
            </div>
          </div>
          <div v-if="DNSData.result">
            <div
              class="mt-5 py-2 px-3 bg-edyel lg:w-7/12 flex items-center gap-2 rounded-full"
              v-if="DNSData.result.status == 'pending'"
            >
              <feather-icon
                icon="ClockIcon"
                svgClasses="w-4 h-4"
                class="text-yellowish mt-1 font-semibold"
              />
              <p class="text-yellowish m-0 p-0 font-semibold">
                Pending nameserver update
              </p>
            </div>
          </div>
          <div v-if="DNSData.result">
            <div
              class="mt-5 py-2 px-3 bg-grens lg:w-7/12 flex items-center gap-2 rounded-full"
              v-if="DNSData.result.status == 'active'"
            >
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="w-4 h-4"
                class="text-success mt-1 font-semibold"
              />
              <p class="text-success">Avtivated nameserver</p>
            </div>
          </div>
        </div>
        <div class="w-full height-step">
          <label class="text-dark fsize16 font-semibold"
            >Scan or import DNS</label
          >

          <div class="border p-2 rounded-lg flex items-center mt-2 gap-2">
            <feather-icon icon="FileIcon" />
            <p class="fsize16 text-gray font-semibold">example.dns</p>
          </div>

          <div class="flex items-center gap-3 mt-4">
            <vs-button
              variant="primary"
              class="rounded-full bg-primary border-0 text-white font-semibold py-3 px-4 sm-fsize14"
              @click="centerDialogVisible = true"
            >
              Import DNS
            </vs-button>
            <vs-button
              type="primary"
              class="bg-light-primary rounded-full text-primary font-semibold"
              @click="scanDNSRecord"
              >Scan DNS</vs-button
            >
          </div>
        </div>

        <div class="height-step">
          <div class="flex justify-between w-full">
            <h6 class="text-dark fsize16 font-semibold">
              Update nameservers in your Domain
            </h6>
            <!-- <feather-icon icon="InfoIcon" /> -->
          </div>
          <p class="text-8f8f8f text-sm font-semibold mt-3">Nameservers:-</p>
          <div
            class="mt-3 bg-f9 p-3 flex justify-between items-center rounded-lg"
            v-if="DNSData.result"
          >
            <p class="text-black font-semibold text-lg" ref="mylinkFirst">
              {{ firstDomain }}
            </p>
            <feather-icon
              icon="CopyIcon"
              svgClasses="w-4 h-4"
              class="cursor-pointer"
              @click="copyDomain(firstDomain)"
            />
          </div>
          <div
            class="mt-3 bg-f9 p-3 flex justify-between items-center rounded-lg"
            v-if="!DNSData.result"
          >
            <p class="text-black font-semibold text-lg">Yet to generate</p>
            <!-- <feather-icon
              icon="CopyIcon"
              svgClasses="w-4 h-4"
              class="cursor-pointer"
            /> -->
          </div>
          <div
            class="mt-5 bg-f9 p-3 flex justify-between items-center rounded-lg"
            v-if="DNSData.result"
          >
            <p class="text-black font-semibold text-lg" ref="mylinkSecond">
              {{ secondDomain }}
            </p>
            <feather-icon
              icon="CopyIcon"
              svgClasses="w-4 h-4"
              class="cursor-pointer"
              @click="copyDomain(secondDomain)"
            />
          </div>
          <div
            class="mt-5 bg-f9 p-3 flex justify-between items-center rounded-lg"
            v-if="!DNSData.result"
          >
            <p class="text-black font-semibold text-lg">Yet to generate</p>
            <!-- <feather-icon
              icon="CopyIcon"
              svgClasses="w-4 h-4"
              class="cursor-pointer"
            /> -->
          </div>
        </div>

        <div class="w-full height-step">
          <h6 class="text-dark fsize16 font-semibold">Check Status</h6>

          <vs-button
            variant="primary"
            class="rounded-full bg-primary border-0 text-white font-semibold py-3 mt-5 px-4 sm-fsize14"
            @click="dnsRecord"
          >
            Check Nameserver
          </vs-button>
          <div class="mt-4 p-3 bg-edyel">
            <p class="font-semibold text-yellowish">
              Registers can take 24 hours to process nameserver updates.
            </p>
          </div>
        </div>

        <div class="">
          <h4 class="text-black fsize16 font-semibold">Completed</h4>
        </div>
      </div>
      <!-- <div class="bg-f9 shadow-lg rounded-lg p-10">
        <h6 class="text-black text-2xl font-semibold">Connect your Domain</h6>
        <p class="text-8f8f8f text-sm font-semibold mt-3">Nameservers:-</p>
        <div
          class="mt-5 bg-white p-4 flex justify-between items-center rounded-lg"
        >
          <p class="text-black font-semibold text-lg">ns1.brained.com</p>
          <feather-icon icon="CopyIcon" class="cursor-pointer" />
        </div>
        <div
          class="mt-5 bg-white p-4 flex justify-between items-center rounded-lg"
        >
          <p class="text-black font-semibold text-lg">ns1.brained.com</p>
          <feather-icon icon="CopyIcon" class="cursor-pointer" />
        </div>
        <div class="mt-5 bg-ffecc7 p-5 rounded-lg">
          <p class="text-black font-medium text-md">
            Connect your domain with BRAINED Servers and we will deploy your
            website on your official domain within 24 to 48 working hours.
          </p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FeatherIcon from "../../../../../../../components/FeatherIcon.vue";
export default {
  components: { FeatherIcon },
  data() {
    return {
      domainName: "",
      firstDomain: "",
      secondDomain: "",
      activeSteps: 1,
      centerDialogVisible: false,
    };
  },
  methods: {
    async checkData() {
      this.$vs.loading();
      await this.$store.dispatch("DNS/checkData");
      if (this.DNSData.result || this.DNSData.DNS_ID) {
        await this.$store.dispatch("DNS/getDNSRecord");
        this.domainName = this.DNSData.result.name;
        this.firstDomain = this.DNSData.result.name_servers[0];
        this.secondDomain = this.DNSData.result.name_servers[1];
      }
      this.$vs.loading.close();
    },
    async scanDNSRecord() {
      this.$vs.loading();
      let { data } = await this.$store.dispatch("DNS/scanDNS");
      if (data.success) {
        this.$swal({
          text: "Your DNS Record Added Successfully",
          icon: "success",

          confirmButtonColor: "#CD3197",
          // cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
      this.activeSteps = 3;
      this.$vs.loading.close();
    },
    async addDomain() {
      this.$vs.loading();
      let payload = {
        domain: this.domainName,
      };
      let { data } = await this.$store.dispatch("DNS/addDomain", payload);
      if (data.success) {
        this.$swal({
          text: "Your Domain Added Successfully",
          icon: "success",

          confirmButtonColor: "#CD3197",
          // cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
      this.checkData();
      this.activeSteps = 2;

      if (data.data.success == true) {
        this.activeSteps = 2;
      }
      this.$vs.loading.close();
    },
    async dnsRecord() {
      this.$vs.loading();

      await this.$store.dispatch("DNS/getDNSRecord");
      if (this.DNSData.result.status == "pending") {
        this.$swal({
          text: "Domain Pending",
          icon: "success",

          confirmButtonColor: "#CD3197",
          // cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
      if (this.DNSData.result.status == "active") {
        this.$swal({
          text: "Domain Activited",
          icon: "success",

          confirmButtonColor: "#CD3197",
          // cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
      if (this.DNSData.result.status == "active") {
        this.activeSteps = 5;
      }
      this.$vs.loading.close();
    },
    copyDomain(data) {
      this.$vs.loading();
      navigator.clipboard.writeText(data);
      this.activeSteps = 4;
      this.$vs.loading.close();
    },
  },
  computed: {
    ...mapState("DNS", ["DNSData"]),
  },
  mounted() {
    this.checkData();

    if (this.DNSData.result || this.DNSData.DNS_ID) {
      this.activeSteps = 2;
      if (this.DNSData.result.status == "active") {
        this.activeSteps = 5;
      }
    }
  },
};
</script>
